import { useEffect, useState } from "react";
import korrectLogo from '../../assets/images/korrectLogoIcon.png';
import TemplateCreate from "./TemplateCreate";
import TemplateList from "./TemplateList";

export default function TemplateIndex() {
 
    let [showTab, setShowTab] = useState(false); 
    let [activeMenu, setActiveMenu] = useState("createTemplate");

    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }

    const closeModal = (e: any) => {
        setShowTab(e);
        const modal = document.getElementById("myModal") as HTMLElement;
        modal?.classList.remove("displayItem");
        modal?.classList.add("displayNoneItem");
        document.body.classList.remove("HiddenoverflowX");
    }
    return (

        <div id="myModal" className="modal pLarge ws-12 ">

            <style>{` 

                .box{ border-radius : 4px !important ;} 
                [class*="btn"], .nav.nav-tabs li, input{ border-radius : 4px !important ;} 
                li{ border-radius : 4px !important ;} 
                .topFrame{ border-radius: 6px; } 
                .tagging span{border-radius: 5px;}

            `}</style>

            <a onClick={() => closeModal(true)} className="btn-xxs modalClose borderNone bgTransparent" style={{ position: "inherit" }} href="../../">
                <i className="icon-close3 danger"></i>
            </a>

            <div className="allowHscroll allowVscroll full-height-vh90 ws-12 box" >

                <div className="ws-12 ">
                    <div className="ws-2 pm borderReset pLarge">
                        <div className="ws-12 text-center pLarge mtll mbl">
                            <img alt="Korrect"  className="pull-none" src={korrectLogo} width={50} />
                        </div>

                        <ul className="main-menu pll prl ws-12">
                            <a className="full-width text-bold text-average text-m mtl ws-12 pbl">Korrect Template</a>
                            <ul >
                                <li className={activeMenu === 'createTemplate' ? "active" : ""}>
                                    <a className="ws-12 text-sl text-normal" onClick={() => { onChangeMenu('createTemplate') }}> Create Template </a>
                                </li>

                                <li className={activeMenu === 'existingTemplate' ? "active" : ""}>
                                    <a className="ws-12 text-sl text-normal" onClick={() => { onChangeMenu('existingTemplate') }}> Exiting Template</a>
                                </li>


                                <li className={activeMenu === 'dspLink' ? "active" : ""}>
                                    <a className="ws-12 text-sl text-normal" onClick={() => { onChangeMenu('dspLink') }}> Dsp list</a>
                                </li>
                            </ul>

                        </ul>
                    </div>


                    {(activeMenu === "createTemplate") && <div className="ws-10 landing pm"> <TemplateCreate activeMenu={activeMenu}/> </div> }
                    {(activeMenu === "existingTemplate") && <div className="ws-10 landing pm"> <TemplateList activeMenu={activeMenu}/></div> }

                </div>
            </div>

        </div>

    )
}